import { WhatsappLogo } from "@phosphor-icons/react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/5527981761251?text=Olá! Vim pelo site e gostaria de mais informações."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform whatsapp-pulse"
      data-testid="whatsapp-floating-button"
      aria-label="Contato via WhatsApp"
    >
      <WhatsappLogo weight="fill" size={32} className="text-white" />
    </a>
  );
};

export default WhatsAppButton;
